module.exports = __webpack_public_path__ + "img/pic_explain03@2x.537bb924.png";